export default __webpack_public_path__ + "static/media/030.d4e6398f.jpg";